import { useEffect } from "react";
import { util } from "../helpers/common";
import { CONVERSATION_CONSTANTS } from "../helpers/constants";

// Import children components to plug in and render.
import ConversationEntry from "./conversationEntry";
import TypingIndicator from "./typingIndicator";
import VacomLogo from "../../../assets/logos/VacomLogo";

export default function MessagingBody({ conversationEntries, conversationStatus, typingParticipants, showTypingIndicator, isCustomerLoggedIn }) {

    useEffect(() => {
        if (conversationStatus === CONVERSATION_CONSTANTS.ConversationStatus.CLOSED_CONVERSATION) {
            // Render conversation closed message.

            // Remove typing indicator.
            typingParticipants = [];
            showTypingIndicator = false;
        }
    }, [conversationStatus]);

    /**
     * Builds a list of conversation entries where each conversation-entry represents an object of type defined in constants#CONVERSATION_CONSTANTS.EntryTypes.
     * @returns {string}
     */
    const conversationEntriesListView = conversationEntries.map(conversationEntry =>
        <ConversationEntry
            key={conversationEntry.messageId}
            conversationEntry={conversationEntry} />
    );

    /**
     * Generates a text with conversation start date and time.
     * @returns {string}
     */
    function generateConversationStartTimeText() {
        if (conversationEntries.length) {
            const conversationStartTimestamp = conversationEntries[0].transcriptedTimestamp;
            const startDate = util.getFormattedDate(conversationStartTimestamp);
            const startTime = util.getFormattedTime(conversationStartTimestamp);
            const conversationStartTimeText = `Konversation gestartet: ${startDate} um ${startTime}`;
            return conversationStartTimeText;
        }
        return "";
    }

    /**
     * Generates a text with conversation end date and time.
     * @returns {string}
     */
    function generateConversationEndTimeText() {
        const conversationEndTimestamp = Date.now();
        const endDate = util.getFormattedDate(conversationEndTimestamp);
        const endTime = util.getFormattedTime(conversationEndTimestamp);
        const conversationEndTimeText = `Konversation beendet: ${endDate} um ${endTime}`;

        return conversationEndTimeText;
    }

    return (
        <div className="messagingBody">
            <div className="messagingInfoHeader">
            <span className="messagingLogoContainer">
                <VacomLogo width={'90%'} height={'90%'}/>
            </span>

                {isCustomerLoggedIn
                    ? <div className="messagingInfoContent">
                        <div className="messagingInfoTitle">VACOM Live Produktberatung</div>
                        <div className="messagingInfoText">Vielen Dank für Ihr Interesse an Vacom. Sollten Sie Fragen zu
                            einem unserer Produkte haben oder Hilfe beim Konfigurieren benötigen, stehen unsere
                            Produktexperten
                            und -expertinnen gerne für Sie bereit. Bitte beachten Sie,
                            dass der Chat erst gestartet wird, wenn Sie eine initiale Nachricht senden.
                        </div>
                    </div>
                    : <div className="messagingInfoContent">
                        <div className="messagingInfoTitle">VACOM Live Produktberatung</div>
                        <div className="messagingInfoText">Vielen Dank für Ihr Interesse an Vacom. Sie sind aktuell nicht angemeldet! Bitte Loggen Sie sich erst ein oder registrieren Sie sich.
                        </div>
                    </div>
                }

            </div>
            {conversationEntries.length > 0 &&
                <p className="conversationStartTimeText">{generateConversationStartTimeText()}</p>}
            <ul className="conversationEntriesListView">
                {conversationEntriesListView}
            </ul>
            {showTypingIndicator && <TypingIndicator typingParticipants={typingParticipants}/>}
            {conversationStatus === CONVERSATION_CONSTANTS.ConversationStatus.CLOSED_CONVERSATION &&
                <p className="conversationEndTimeText">{generateConversationEndTimeText()}</p>}
        </div>
    );
}
